import { render, staticRenderFns } from "./messagePro.vue?vue&type=template&id=2c55a304&scoped=true&"
import script from "./messagePro.vue?vue&type=script&lang=js&"
export * from "./messagePro.vue?vue&type=script&lang=js&"
import style0 from "./messagePro.vue?vue&type=style&index=0&id=2c55a304&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c55a304",
  null
  
)

component.options.__file = "messagePro.vue"
export default component.exports